import { Alert, Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../../Hooks/useHandleApiResponse';
import { getSessionPreferencesSync } from '../../../../../redux/features/croSlice';

export default function SessionSyncModal({ row, onClose }) {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const [submitting, setSubmitting] = useState(false);

  const hasScheduledSessions = Boolean(row?.scheduled_sessions_count);

  if (!row) return null;

  // Same functionality as the Sync button on the session-preference page:
  // GET scheduled-calendar/sync-calendar?subject_enrollment_id=...
  const handleSync = () => {
    setSubmitting(true);
    dispatch(getSessionPreferencesSync({ subject_enrollment_id: row?.subject_enrollment_id }))
      .then((res) =>
        handleApiResponse(res, {
          onSuccess: () => onClose(),
          onFailed: () => console.log('Session sync failed'),
        }),
      )
      .finally(() => setSubmitting(false));
  };

  return (
    <Box p={2}>
      <Typography fontWeight={600} mb={2}>
        Student: {row?.student_name}
      </Typography>

      {!hasScheduledSessions ? (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <strong>No scheduled sessions</strong>
          <br />
          There are no scheduled sessions to sync for this subject.
        </Alert>
      ) : (
        <Alert severity="success" sx={{ mb: 2 }}>
          <strong>Disclaimer</strong>
          <br />
          Scheduled sessions will be synced with Lens/Wise.
        </Alert>
      )}

      <Box display="flex" justifyContent="flex-end" gap={2}>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={handleSync} disabled={!hasScheduledSessions || submitting}>
          {submitting ? 'Syncing...' : 'Sync'}
        </Button>
      </Box>
    </Box>
  );
}
